import { getID } from "src/libs/utilities";
import { LANDING_TYPE_CONTENT, } from "../interfaces";

export default function tabs(): any[] {
    return [
        {
            "id": getID("tabs"),
            "vertical": true,
            "type": LANDING_TYPE_CONTENT.TABS,
            "items": [
                {
                    "id": getID("tab1"),
                    "title": "Марк Твен",
                    "panel":  [
                        {
                            "id": getID("image"),
                            "type": LANDING_TYPE_CONTENT.IMAGE,
                            "width": 250,
                            "height": 250,
                            "horizontal_align": "start",
                            "hover_size": 10,
                            "src": "https://www.b17.ru/foto/uploaded/upl_1511910625_156776.jpg",
                            "style": {
                            "marginBottom": 40
                            }

                        },
                        {
                            "id": getID("html"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Через 20 лет вы будете больше разачарованны теми вещами, которые вы не делали, чем теми, которые вы сделали. Так отчальте от тихой пристани, Почувствуйте попутный ветер в вашем парусе. Двигайтесь вперед! Мечтайте! Открывайте!"
                            ,
                            "style": {
                            "marginBottom": 30
                            }
                        },
                        {
                            "id": getID("html-2"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Чтобы быть счастливым, надо жить в своем собственном раю! Неужели вы думали, что один и тот же рай может удовлетворить всех людей без исключения?"
                        }
                    ] 
                },
                {
                "id": getID("tab2"),
                "title": "Аркадий и Борис Стругацкие",
                "panel": [
                    {
                        "id": getID("image"),
                        "type": LANDING_TYPE_CONTENT.IMAGE,
                        "width": 250,
                        "height": 250,
                        "horizontal_align": "start",
                        "hover_size": 10,
                        "src": "https://avatars.dzeninfra.ru/get-zen_doc/271828/pub_68f8a616fc20fc05aa3339d8_68f8e4783b3ecd35b5060b27/scale_1200",
                        "style": {
                            "marginBottom": 40
                        }

                    },
                    {
                        "id": getID("html1"),
                        "type": LANDING_TYPE_CONTENT.HTML,
                        "text": "Восемьдесят три процента всех дней в году начинаются одинаково: звенит будильник."
                        ,
                        "style": {
                            "marginBottom": 30
                        }
                    },
                    {
                        "id": getID("html-2"),
                        "type": LANDING_TYPE_CONTENT.HTML,
                        "text": "Иногда я спрашиваю себя: какого черта мы так крутимся? Чтобы заработать деньги? Но на кой черт нам деньги, если мы только и делаем, что крутимся?..",
                        "style": {
                            "marginBottom": 30
                        }
                    },
                    {
                        "id": getID("html-2"),
                        "type": LANDING_TYPE_CONTENT.HTML,
                        "text": "Умные нам ненадобны. Надобны верные." 
                    }
                    ]
                }, 
                {
                "id": getID("tab3"),
                "title": "Альберт Эйнштейн",
                "panel": [
                    {
                        "id": getID("image"),
                        "type": LANDING_TYPE_CONTENT.IMAGE,
                        "width": 250,
                        "height": 250,
                        "horizontal_align": "start",
                        "hover_size": 10,
                        "src": "https://avatars.dzeninfra.ru/get-zen_doc/5218808/pub_61dbf2371901ff788f03204b_61dbf28e6865712f7575aeea/scale_1200",
                        "style": {
                            "marginBottom": 40
                        }

                    },
                    {
                        "id": getID("html-1"),
                        "type": LANDING_TYPE_CONTENT.HTML,
                        "text": "Только дурак нуждается в порядке — гений господствует над хаосом"
                        ,
                        "style": {
                            "marginBottom": 30
                        }
                    },
                    {
                        "id": getID("html-2"),
                        "type": LANDING_TYPE_CONTENT.HTML,
                        "text": "Есть только два способа прожить жизнь: первый – будто чудес не существует, второй – будто кругом одни чудеса",
                        "style": {
                            "marginBottom": 30
                        }
                    },
                    {
                        "id": getID("html-3"),
                        "type": LANDING_TYPE_CONTENT.HTML,
                        "text": "Невозможно решить проблему на ее уровне – для решения нужно стать выше этой проблемы." 
                    }
                    ]
                }
            ],
            defaultTitle: "Вкладки. Переключение справа"
        }, 
        {
            "id": getID("tabs"),
            "type": LANDING_TYPE_CONTENT.TABS,
            "vertical": false,
            "items": [
                {
                    "id": getID("tab1"),
                    "title": "Марк Твен",
                    "panel":  [
                        {
                            "id": getID("image"),
                            "type": LANDING_TYPE_CONTENT.IMAGE,
                            "width": 250,
                            "height": 250,
                            "horizontal_align": "start",
                            "hover_size": 10,
                            "src": "https://www.b17.ru/foto/uploaded/upl_1511910625_156776.jpg",
                            "style": {
                                "marginTop": 40,
                                "marginBottom": 40,
                            }

                        },
                        {
                            "id": getID("html"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Через 20 лет вы будете больше разачарованны теми вещами, которые вы не делали, чем теми, которые вы сделали. Так отчальте от тихой пристани, Почувствуйте попутный ветер в вашем парусе. Двигайтесь вперед! Мечтайте! Открывайте!"
                            ,
                            "style": {
                            "marginBottom": 30
                            }
                        },
                        {
                            "id": getID("html-2"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Чтобы быть счастливым, надо жить в своем собственном раю! Неужели вы думали, что один и тот же рай может удовлетворить всех людей без исключения?"
                        }
                    ] 
                },
                {
                    "id": getID("tab2"),
                    "title": "Аркадий и Борис Стругацкие",
                    "panel": [
                        {
                            "id": getID("image"),
                            "type": LANDING_TYPE_CONTENT.IMAGE,
                            "width": 250,
                            "height": 250,
                            "horizontal_align": "start",
                            "hover_size": 10,
                            "src": "https://avatars.dzeninfra.ru/get-zen_doc/271828/pub_68f8a616fc20fc05aa3339d8_68f8e4783b3ecd35b5060b27/scale_1200",
                            "style": {
                                "marginTop": 40,
                                "marginBottom": 40,
                            }

                        },
                        {
                            "id": getID("html1"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Восемьдесят три процента всех дней в году начинаются одинаково: звенит будильник."
                            ,
                            "style": {
                                "marginBottom": 30
                            }
                        },
                        {
                            "id": getID("html-2"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Иногда я спрашиваю себя: какого черта мы так крутимся? Чтобы заработать деньги? Но на кой черт нам деньги, если мы только и делаем, что крутимся?..",
                            "style": {
                                "marginBottom": 30
                            }
                        },
                        {
                            "id": getID("html-2"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Умные нам ненадобны. Надобны верные." 
                        }
                    ]
                }, 
                {
                    "id": getID("tab3"),
                    "title": "Альберт Эйнштейн",
                    "panel": [
                        {
                            "id": getID("image"),
                            "type": LANDING_TYPE_CONTENT.IMAGE,
                            "width": 250,
                            "height": 250,
                            "horizontal_align": "start",
                            "hover_size": 10,
                            "src": "https://avatars.dzeninfra.ru/get-zen_doc/5218808/pub_61dbf2371901ff788f03204b_61dbf28e6865712f7575aeea/scale_1200",
                            "style": {
                                "marginTop": 40,
                                "marginBottom": 40,
                            }

                        },
                        {
                            "id": getID("html-1"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Только дурак нуждается в порядке — гений господствует над хаосом"
                            ,
                            "style": {
                                "marginBottom": 30
                            }
                        },
                        {
                            "id": getID("html-2"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Есть только два способа прожить жизнь: первый – будто чудес не существует, второй – будто кругом одни чудеса",
                            "style": {
                                "marginBottom": 30
                            }
                        },
                        {
                            "id": getID("html-3"),
                            "type": LANDING_TYPE_CONTENT.HTML,
                            "text": "Невозможно решить проблему на ее уровне – для решения нужно стать выше этой проблемы." 
                        }
                    ]
                }
            ],
            defaultTitle: "Вкладки. Переключение сверху"
        }, 
    ]
}